export default "__VITE_ASSET__ClTPo4F9__"